export default "/_next/static/images/8d326a73d81693f190853589673fcf28.png";